<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="('Request ' | translate) + (featureType | titlecase)"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    <tidy-card>
      <tidy-row class="extra-bottom-padding" [align]="'center'">
        <tidy-image

          [src]="selectedFeature ? selectedFeature?.icon_url : 'assets/img/question.svg'"
          style="width:80%; max-height: 200px" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [header]="selectedFeature?.name" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="selectedFeature?.description" />
      </tidy-row>
      <tidy-row class="extra-top-padding extra-bottom-padding">
        <tidy-divider />
      </tidy-row>
      <form [formGroup]="form" novalidate action="#">
        <ng-container>
          <tidy-row class="field-top-padding">
            <tidy-textarea
              formControlName="note"
              [form]="form.controls.notes"
              [label]="'Any notes for our concierge?'"
              [icon]="'assets/svg/information-circle.svg'" />
          </tidy-row>
        </ng-container>
      </form>
    </tidy-card>

    <tidy-button
      [text]="('Request ' | translate) + (featureType | titlecase)"
      [action]="boundRequestFeature"
      class="primary" />

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
